import React from 'react';

import ContactAlert from '../Common/ContactAlert';

const AlertSemPlano = () => {
  return (
    <ContactAlert
      message="Deseja utilizar a plataforma Tertium para solicitar documentos de empresas que prestam serviços para sua empresa?"
    />
  )
}

export default AlertSemPlano
